import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import img1 from '../assets/defaultimage1.jpg';
import img2 from '../assets/defaultImage2.jpg';
import img3 from '../assets/defaultImage3.jpg';

const servicesList = [
    {
        title: 'Lawn Care & Maintenance',
        desc: 'Weekly mowing, edging, trimming, and fertilizer programs to keep your lawn healthy and green.',
        img: img1
    },
    {
        title: 'Landscape Design',
        desc: 'Custom landscape designs including planting plans, softscapes, and long-term maintenance advice.',
        img: img2
    },
    {
        title: 'Hardscaping',
        desc: 'Patios, walkways, retaining walls and other hardscape features to transform your outdoor living area.',
        img: img3
    },
    {
        title: 'Irrigation & Drainage',
        desc: 'Irrigation installation, repair, and seasonal tune-ups to keep your landscape properly watered.',
        img: img1
    },
    {
        title: 'Seasonal Cleanups',
        desc: 'Spring and fall cleanups, leaf removal, pruning and debris hauling to prepare your yard for the season.',
        img: img2
    },
    {
        title: 'Mulching & Planting',
        desc: 'Professional mulching and planting services to improve curb appeal and plant health.',
        img: img3
    }
];

const Services = () => {
    return (
        <Container className="my-5">
            <Row>
                <Col>
                    <h1 className="mb-3">Our Services</h1>
                    <p className="text-muted">Comprehensive landscaping services for residential and commercial properties.</p>
                </Col>
            </Row>

            <Row className="mt-4">
                {servicesList.map((s, idx) => (
                    <Col key={idx} md={4} className="mb-4">
                        <Card className="h-100 shadow-sm">
                            <Card.Img variant="top" src={s.img} style={{height: 180, objectFit: 'cover'}} />
                            <Card.Body className="d-flex flex-column">
                                <Card.Title>{s.title}</Card.Title>
                                <Card.Text className="text-muted" style={{flexGrow:1}}>{s.desc}</Card.Text>
                                <div className="mt-3">
                                    <Button href="/contact-us" variant="success">Request Quote</Button>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
        </Container>
    );
}

export default Services;